import { render, staticRenderFns } from "./bucket.vue?vue&type=template&id=b6030b22&scoped=true"
import script from "./bucket.vue?vue&type=script&lang=js"
export * from "./bucket.vue?vue&type=script&lang=js"
import style0 from "./bucket.vue?vue&type=style&index=0&id=b6030b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6030b22",
  null
  
)

export default component.exports